import React from 'react';
import { Link } from 'react-router-dom';

interface AuthLayoutProps {
  children: React.ReactNode;
  title: string;
  subtitle: string;
  showBackToHome?: boolean;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ 
  children, 
  title, 
  subtitle, 
  showBackToHome = true 
}) => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <div className="flex items-center space-x-3">
              <img 
                src="/logo-pecaja.png" 
                alt="PeçaJá & Sobratema" 
                className="h-8 w-auto object-contain"
              />
            </div>

            {/* Navigation */}
            <nav className="flex items-center space-x-4">
              {showBackToHome && (
                <Link to="/" className="nav-link">
                  Voltar ao Início
                </Link>
              )}
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center py-12 px-4">
        <div className="max-w-7xl w-full">
          {/* Header */}
          <div className="text-center mb-8">
            <div className="flex items-center justify-center mb-4">
              <img 
                src="/logo-pecaja.png" 
                alt="PeçaJá & Sobratema" 
                className="h-12 w-auto object-contain"
              />
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">
              {title}
            </h1>
            <p className="text-gray-600">
              {subtitle}
            </p>
          </div>

          {/* Content */}
          {children}
        </div>
      </main>

      {/* Footer */}
      <footer className="footer mt-auto">
        <div className="container">
          <div className="text-center">
            <p className="text-sm text-gray-300">
              © 2024 PeçaJá. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AuthLayout; 